import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { Observable, Subscriber, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { KeycloakService } from 'keycloak-angular';
import { MobileService } from './mobile.services';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public access_token: string;
  public customerCode: string;
  public customerName: string;
  public lastLoginDate: string;
  public lastFailedLogin:string;
  public loginDateTime: string;
  public branchCode: string;
  public expiresin: string;
  public entity_code: string;
  public refreshToken: string;
  public userName: string;
  public userImage: string;
  public userId:string;

  constructor(
    private httpClient: HttpClient,
    private router: Router) { }

  public redirectUrl: string = 'welcome/appnavigator';
  public ignorePathList: string[] = ['dashboard'];

  decodeJwt(token) {
    if (token && token != "") {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    }
    return;
  }

  setToken(loginauth:any) {
    this.setRefreshToken(loginauth.refreshToken);
    this.setAuthToken(loginauth.authToken);
    let decodesAccessToken = this.decodeJwt(loginauth.authToken);
    this.setUserDetails(decodesAccessToken);
    const startSession = new CustomEvent('startSession', { detail: this });
    window.dispatchEvent(startSession);
  }

  setAuthToken(token:string){
    this.access_token = token;
    sessionStorage.setItem('access_token', token);
  }

  getToken() {
    return this.access_token;
  }

  removeToken() {
    this.access_token = undefined;
    sessionStorage.removeItem('access_token');
  }

  setUserDetails(decodesAccessToken) {
    this.setCustomerCode(decodesAccessToken.AddAttribute2);
    this.setUserName(decodesAccessToken.AddAttribute3);
    this.setCustomerName(decodesAccessToken.customerName);
    this.setLastLoginDate(decodesAccessToken.lastLoginDate);
    this.setLastLoginFailureDateTime(decodesAccessToken.lastFailedLogin);
    this.setLoginDateTime(decodesAccessToken.loginDateTime);
    this.setBranchCode(decodesAccessToken.branchCode);
    this.setExpiresin(decodesAccessToken.expiresin);
    this.setUserId(decodesAccessToken.AddAttribute1);
    // this.setRefreshToken(decodesAccessToken.refreshToken);
  }

  setUserName(user_name) {
    this.userName = user_name;
  }
  getUserName():string {
    return this.userName;
  }

  setUserId(userId:string){
    this.userId = userId;
  }
  getUserId():string{
    return this.userId;
  }

  setCustomerName(customerName) {
    this.customerName = customerName;
  }
  getCustomerName():string {
    return this.customerName;
  }


  public getLastLoginDate() {
    return this.lastLoginDate;
  }

  public setLastLoginDate(lastLoginDate) {
    this.lastLoginDate = lastLoginDate;
  }
  public getLastLoginFailureDateTime() {
    return this.lastFailedLogin;
  }

  public setLastLoginFailureDateTime(lastFailedLogin) {
    this.lastFailedLogin = lastFailedLogin;
  }

  public getLoginDateTime() {
    return this.loginDateTime;
  }

  setLoginDateTime(loginDateTime) {
    this.loginDateTime = loginDateTime;
  }

  public getBranchCode() {
    return this.branchCode;
  }

  public setBranchCode(branchCode) {
    this.branchCode = branchCode;
  }

  public getExpiresin() {
    return this.expiresin;
  }

  public setExpiresin(expiresin) {
    this.expiresin = expiresin;
  }

  public getEntity_code() {
    return this.entity_code;
  }

  public setEntity_code(entity_code) {
    this.entity_code = entity_code;
  }

  public getRefreshToken() {
    return this.refreshToken;
  }

  public setRefreshToken(refreshToken) {
    sessionStorage.setItem("refreshToken", refreshToken);
    this.refreshToken = refreshToken;
  }

  isLoggedIn() {
    let accessToken = sessionStorage.getItem('access_token');
    return accessToken != undefined && accessToken != null;
  }

  getCustomerCode() {
    return this.customerCode
  }

  setCustomerCode(customerCode) {
    if(customerCode) sessionStorage.setItem("customerCode", customerCode);
    this.customerCode = customerCode;
  }


  async logout() {
    console.log("logout...");
    this.clearSession();
    this.router.navigate(['login']);
  }

  clearSession(){
    let deviceId = sessionStorage.getItem('deviceId');
    sessionStorage.clear();
    sessionStorage.setItem("deviceId", deviceId);
  }

}
